import { C as CosmosImage$1, d as defineCustomElement$1 } from './p-9z54e4xr.js';

const CosmosImage = CosmosImage$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosImage, defineCustomElement };
